export const VIDEO_MAX_LENGTH = 60;
export const VIDEO_MIN_LENGTH = 15;
